<template>
  <div class="add-service-page">
    <div class="page-header">
      <h1>Dodaj usługę</h1>
      <button class="btn-outline" @click="$router.push('/firm-profile/profile/services-provided/')">Wróć do usług</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Nowa usługa</h2>
        <p class="section-subtitle">Uzupełnij formularz i zapisz usługę w profilu.</p>
      </div>

      <form class="service-form" @submit="(e) => addNewService(e)">
        <div class="form-group">
          <label for="serviceName">Nazwa</label>
          <input
              type="text"
              id="serviceName"
              placeholder="Nazwa usługi"
              v-model="service.title"
              @input="filterTitles"
              required
              maxlength="50"
              minlength="3"
          >
        </div>

        <div class="example-titles" v-if="service.title && titles && titles.length > 0">
          <span v-for="title in titles" :key="title.id" @click="service.title = title.content">
            {{ title.content }}
          </span>
        </div>

        <div class="form-group">
          <label for="shortDescription">Krótki opis</label>
          <textarea
              id="shortDescription"
              placeholder="Krótki opis"
              v-model="service.short_description"
              required
              maxlength="350"
              minlength="20"
          ></textarea>
        </div>

        <div class="form-group">
          <label for="description">Treść</label>
          <textarea
              id="description"
              placeholder="Treść"
              v-model="service.description"
              required
              maxlength="3000"
              minlength="80"
          ></textarea>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label for="address">Adres</label>
            <input
                type="text"
                id="address"
                placeholder="Adres"
                v-model="service.address"
                required
                maxlength="50"
                minlength="3"
            >
          </div>

          <div class="form-group">
            <label for="state">Województwo</label>
            <select id="state" v-model="service.state">
              <option :value="state.value" :key="state.value" v-for="state in states">{{ state.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <label for="phone">Numer telefonu</label>
            <input type="tel" id="phone" placeholder="Numer telefonu" v-model="service.phone" required pattern="[0-9]{9}">
          </div>

          <div class="form-group">
            <label for="price">Cena</label>
            <input type="number" id="price" placeholder="Cena" v-model="service.price" required>
          </div>

          <div class="form-group">
            <label for="advanceAmount">Wartość zaliczki (%)</label>
            <input type="number" id="advanceAmount" placeholder="Zaliczka" v-model="service.advanceAmount" max="100" required>
          </div>

          <div class="form-group">
            <label for="specialist">Specjalista</label>
            <select id="specialist" v-model="service.specialist" @change="getEmployees">
              <option :value="null" :key="null">-- Wybierz specjalistę --</option>
              <option :value="specialist.id" :key="specialist.id" v-for="specialist in specialists">{{ specialist.firstname }} {{ specialist.lastname }} ({{ specialist.name }})</option>
            </select>
          </div>

          <div class="form-group">
            <label for="employee">Pracownik</label>
            <select id="employee" v-model="service.employee">
              <option :value="null" :key="null">-- Wybierz pracownika --</option>
              <option :value="employee.id" :key="employee.id" v-for="employee in employees">{{ employee.firstname }} {{ employee.lastname }}</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label for="photo">Zdjęcie wyróżniające</label>
          <input type="file" id="photo" @change="(e) => onFileUpload(e)" accept="image/png, image/jpeg" required>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary">Zatwierdź</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'BizProfileAddServiceVue',
  setup() {
    useMeta({ title: 'Dodaj usługę' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      states: [],
      service: {
        title: '',
        short_description: '',
        description: '',
        address: '',
        state: '',
        phone: '',
        price: '',
        photo: null,
        specialist: null,
        employee: null,
        advanceAmount: 0,
      },
      specialists: [],
      employees: [],
      titles: null,
      titlesConst: null,
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 5) {
      this.$router.push('/login');
    }

    if (this.appStore.isSubscribed) {
      this.getStates();
      this.getSpecialists();
      this.getTitles();
    } else {
      this.$router.push('/firm-profile');
    }
  },
  methods: {
    async getTitles() {
      if (!this.service.specialist) return;
      const res = await axios.get(`/GetServiceTitles/${this.service.specialist.category_id}`);
      this.titles = res.data.serviceTitles;
      this.titlesConst = res.data.serviceTitles;
    },
    filterTitles() {
      this.titles = this.titlesConst;
      if (!this.titles) return;
      this.titles = this.titles.filter(title => title.content.toLowerCase().includes(this.service.title.toLowerCase()));
    },
    getStates() {
      axios.get('/State').then(res => {
        this.states = [];
        res.data.forEach((item) => {
          this.states.push({
            name: item.name,
            value: `${item.id}`,
          });
        });
        if (this.states.length > 0) {
          this.service.state = this.states[0].value;
        }
      });
    },
    onFileUpload(event) {
      this.service.photo = event.target.files[0];
    },
    addNewService(e) {
      e.preventDefault();
      if (this.service.photo) {
        const newServiceData = {
          name: this.service.title,
          short_description: this.service.short_description,
          description: this.service.description,
          address: this.service.address,
          state_id: this.service.state,
          phone: this.service.phone,
          price: this.service.price,
          photo: this.service.photo,
          specialist_id: this.service.specialist,
          employee_id: this.service.employee ? this.service.employee : null,
          advanceAmount: this.service.advanceAmount,
        };
        axios.post('/Service', newServiceData, {
          headers: {
              ['Content-Type']: 'multipart/form-data',
          },
        }).then(res => {
          if (String(res.status).charAt(0) === '2') {
            this.appStore.setIsSuccess('Pomyślnie dodano usługę');
            this.$router.push('/firm-profile/services-provided/');
          }
        });
      } else {
        this.appStore.setIsAlert('wgraj zdjęcie');
      }
    },
    async getSpecialists() {
      this.specialists = (await axios.get('/FirmSpecialists', authHeader())).data;
    },
    async getEmployees() {
      if (! this.service.specialist) return;
      const res = await axios.get(`/SpecialistEmployees/${this.service.specialist}`, authHeader());
      this.employees = res.data;
    },
  },
};
</script>

<style scoped lang='scss'>
.add-service-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0,0,0,.08);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
}

.section-subtitle {
  margin: 6px 0 0;
  font-size: 1.4rem;
  color: #6b7280;
}

.service-form {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(160px, 1fr));
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  color: #374151;
  font-weight: 600;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
}

.form-group textarea {
  min-height: 120px;
  resize: vertical;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  border-color: #10b981;
}

.example-titles {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
}

.example-titles span {
  display: block;
  padding: 8px 10px;
  font-size: 1.4rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
}

.example-titles span:last-child {
  border-bottom: none;
}

.example-titles span:hover {
  background-color: #f3f4f6;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}
.btn-primary:hover {
  background: #ea6c0a;
}

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .add-service-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>